
export default (self) => {
    self.$eventBus.$on('message', (msg, type) => {
        type = type ? type : 'info';
        msg = self.$t(msg);
        self.$message[type](msg);
    })
}